export const practiceAddressTypeMapping = {
    Private: "Telehealth only - Provide services exclusively online. Address remains hidden Klarity and other channels.",
    Invitation: "By appointment only - Address will be shown on Klarity and other channels.",
    "Walk-in": "Welcome walk-in welcome - Address will be shown on Klarity and other channels.",
}
